import { Box, MenuItem } from "@mui/material";
import { DataGrid, GridColumnMenu, GridColumnMenuContainer, GridToolbar } from "@mui/x-data-grid";
import React, { useState, useRef, useEffect } from "react";

const EliteTable = ({ rows, columns, onFilterChange, pageSize, rowsPerPageOptions, filters, paginationMode, onPageChange, rowCount, page, loading,
    filterVisibility,
    setFilterVisibility }) => {
    const [localFilters, setLocalFilters] = useState(filters || {});  // Local input state
    const debounceTimeout = useRef(null);

    // Sync local filters with parent filters if they change
    useEffect(() => {
        setLocalFilters(filters);
    }, [filters]);

    const handleFilterChange = (field, value) => {
        setLocalFilters((prev) => ({
            ...prev,
            [field]: value,
        }));

        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(() => {
            onFilterChange(field, value);
        }, 300);
    };

    const handleToggleFilter = (field) => {
        setFilterVisibility((prev) => ({
            ...prev,
            [field]: !prev[field],
        }));
    };

    const enhancedColumns = columns.map((col) => ({
        ...col,
        sortable: false,
        headerAlign: "start",
        renderHeader: (params) => (
            <Box onClick={(e) => e.stopPropagation()}>
                {filterVisibility[col.field] ? (
                    <input
                        style={{ height: "100%", padding: "6px", borderRadius: "4px" }}
                        placeholder={`Filter by ${col.headerName}`}
                        value={localFilters[col.field] || ""}
                        onChange={(e) => handleFilterChange(col.field, e.target.value)}
                    />
                ) : (
                    <div>{params.colDef.headerName}</div>
                )}
            </Box>
        ),
    }));

    return (
        <Box sx={{ height: 600, width: "100%" }}>
            <DataGrid
                loading={loading}
                onPageChange={onPageChange}
                page={page}
                rowCount={rowCount}
                paginationMode={paginationMode}
                disableColumnFilter
                rows={rows}
                columns={enhancedColumns}
                pageSize={pageSize}
                rowsPerPageOptions={rowsPerPageOptions}
                disableColumnMenu={false}
                components={{
                    ColumnMenu: CustomColumnMenu,
                    Toolbar: GridToolbar
                }}
                componentsProps={{
                    columnMenu: {
                        onToggleFilter: handleToggleFilter,
                    },
                }}
            />
        </Box>
    );
};

const CustomColumnMenu = (props) => {
    const { hideMenu, currentColumn, onToggleFilter } = props;

    const handleClick = (event) => {
        event.stopPropagation();
        onToggleFilter(currentColumn.field);
        hideMenu(event);
    };

    return (
        <GridColumnMenuContainer hideMenu={hideMenu}>
            <MenuItem onClick={handleClick}>Filter</MenuItem>
            <GridColumnMenu hideMenu={hideMenu} {...props} />
        </GridColumnMenuContainer>
    );
};

export default EliteTable;
